/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backtolistings2Inputs */

const en_backtolistings2 = /** @type {(inputs: Backtolistings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to places`)
};

const de_backtolistings2 = /** @type {(inputs: Backtolistings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu den Orten`)
};

/**
* | output |
* | --- |
* | "Back to places" |
*
* @param {Backtolistings2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const backtolistings2 = /** @type {((inputs?: Backtolistings2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backtolistings2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backtolistings2(inputs)
	return de_backtolistings2(inputs)
});
export { backtolistings2 as "backToListings" }